import type { IssueTypeId, ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { performUpdateIssueType } from '../../services/jira/update-issue-type.tsx';
import type { IssueTypeModifiableProps, State } from '../types.tsx';

export const updateIssueType =
	(issueTypeId: IssueTypeId, projectId: ProjectId, update: IssueTypeModifiableProps) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();
		const currentIssueType = state.issueTypesById[issueTypeId];

		if (!currentIssueType) {
			return;
		}

		setState({
			issueTypesById: {
				...state.issueTypesById,
				[issueTypeId]: {
					...currentIssueType,
					...update,
				},
			},
		});

		try {
			await performUpdateIssueType(issueTypeId, projectId, {
				name: update.name,
				description: update.description,
				avatarId: Number(update.avatarId),
			});
		} catch (err) {
			setState(state);
		}
	};
